module.exports = __webpack_public_path__ + "static/media/nft.709b6fbe.svg";